// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file inventory/purchase_activity.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { PurchaseActivityItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.PurchaseActivityRequest
 */
export class PurchaseActivityRequest extends Message<PurchaseActivityRequest> {
  /**
   * Unique identifier for the purchase order
   *
   * @generated from field: string purchase_order_id = 1;
   */
  purchaseOrderId = "";

  /**
   * Unique identifier for the purchase request
   *
   * @generated from field: string purchase_request_id = 2;
   */
  purchaseRequestId = "";

  /**
   * Unique identifier for the purchase invoice
   *
   * @generated from field: string purchase_invoice_id = 3;
   */
  purchaseInvoiceId = "";

  constructor(data?: PartialMessage<PurchaseActivityRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PurchaseActivityRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "purchase_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "purchase_request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "purchase_invoice_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PurchaseActivityRequest {
    return new PurchaseActivityRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PurchaseActivityRequest {
    return new PurchaseActivityRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PurchaseActivityRequest {
    return new PurchaseActivityRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PurchaseActivityRequest | PlainMessage<PurchaseActivityRequest> | undefined, b: PurchaseActivityRequest | PlainMessage<PurchaseActivityRequest> | undefined): boolean {
    return proto3.util.equals(PurchaseActivityRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.PurchaseActivityResponse
 */
export class PurchaseActivityResponse extends Message<PurchaseActivityResponse> {
  /**
   * List of purchase activities
   *
   * @generated from field: repeated com.neulink.pharmacy.PurchaseActivityItem activities = 1;
   */
  activities: PurchaseActivityItem[] = [];

  constructor(data?: PartialMessage<PurchaseActivityResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PurchaseActivityResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "activities", kind: "message", T: PurchaseActivityItem, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PurchaseActivityResponse {
    return new PurchaseActivityResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PurchaseActivityResponse {
    return new PurchaseActivityResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PurchaseActivityResponse {
    return new PurchaseActivityResponse().fromJsonString(jsonString, options);
  }

  static equals(a: PurchaseActivityResponse | PlainMessage<PurchaseActivityResponse> | undefined, b: PurchaseActivityResponse | PlainMessage<PurchaseActivityResponse> | undefined): boolean {
    return proto3.util.equals(PurchaseActivityResponse, a, b);
  }
}

